import Image from 'next/image'
import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import type {JSX} from 'react'
import {
	Icon as CIcon,
	type IconSize,
} from '@/products/flexible-web-toolkit/components/icon'
import {loadImageFromKontentAI} from '@/image-loader'
import type {Block} from '@/services/kontent-ai/types'
import {colorWithFallback} from '@/utilities/hooks/color-with-fallback'

export type IconContentItem = IContentItem<{
	icon: Elements.AssetsElement
	/** @deprecated Use brandColor instead */
	brand: Elements.MultipleChoiceElement
	brandColor: Elements.CustomElement
	size: Elements.MultipleChoiceElement
}>

export const IconBlock: Block<IconContentItem> = ({
	block,
	page,
}): JSX.Element => {
	// Color priority: brandColor (new picker) → brand (deprecated dropdown) → page config → primary
	const {hexCode: iconBorderHex} = colorWithFallback({
		blockColor: block.elements.brandColor,
		blockColorLegacy: block.elements.brand,
		pageConfig: page.elements.config[0],
		fallbackColorId: 'primary',
	})

	return (
		<div className="flex justify-center py-4">
			<CIcon
				borderHexColor={iconBorderHex ?? undefined}
				size={(block.elements.size[0]?.codename || 'lg') as IconSize}
			>
				<div className="relative h-full w-full">
					{block.elements.icon[0] ? (
						<Image
							alt={block.elements.icon[0].description ?? ''}
							fill
							loader={loadImageFromKontentAI}
							src={block.elements.icon[0].url}
						/>
					) : null}
				</div>
			</CIcon>
		</div>
	)
}
